import PropTypes from "prop-types";
import React from "react";

const SidebarListItem = (props) => {
  const { title } = props;

  return (
    <div className="SidebarListItem">
      <span className="SidebarListItem__title fs-16 d-block tw:font-bold">{title}</span>
    </div>
  );
};

SidebarListItem.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SidebarListItem;
